const togglePercentagesComponent = function togglePercentagesComponent() {};

togglePercentagesComponent.prototype.init = function init(params) {
  this.params = params;
  this.eGui = document.createElement('div');
  this.eGui.className = 'ag-header-group-cell-label';

  const faStack = [
    '<span class="fa-stack">',
    '<i class="fa fa-check fa-stack-1x"></i>',
    '</span>',
  ].join('');

  this.eGui.innerHTML =
    `<span class="toggle-percentages">
      ${this.params.displayName}  ${faStack}
    </span>`;

  this.onPercentageToggleClick = this.expandOrCollapse.bind(this);
  this.ePercentToggleButton = this.eGui.querySelector('.toggle-percentages');
  this.ePercentToggleButton.addEventListener('click', this.onPercentageToggleClick);

  this.onExpandChangedListener = this.syncExpandButtons.bind(this);
  this.params.columnGroup.getOriginalColumnGroup().addEventListener('expandedChanged', this.onExpandChangedListener);

  this.syncExpandButtons();
};

togglePercentagesComponent.prototype.getGui = function getGui() {
  return this.eGui;
};

togglePercentagesComponent.prototype.expandOrCollapse =
  function expandOrCollapse() {
    const currentState =
      this.params.columnGroup.getOriginalColumnGroup().isExpanded();
    this.params.setExpanded(!currentState);
  };

// TODO:  refactor.  Brought in from ag-grid docs
togglePercentagesComponent.prototype.syncExpandButtons =
  function syncExpandButtons() {
    const isExpanded =
      this.params.columnGroup.getOriginalColumnGroup().isExpanded();

    // TODO: refactor to not use functions
    function collapsed(toDeactivate) {
      toDeactivate.className = `${toDeactivate.className.split(' ')[0]} collapsed`;
    }

    function expanded(toActivate) {
      toActivate.className = `${toActivate.className.split(' ')[0]} expanded`;
    }

    if (isExpanded) {
      expanded(this.ePercentToggleButton);
    } else {
      collapsed(this.ePercentToggleButton);
    }
  };

togglePercentagesComponent.prototype.destroy = function destroy() {
  this.ePercentToggleButton.removeEventListener('click', this.onPercentageToggleClick);
};

export default togglePercentagesComponent;



// WEBPACK FOOTER //
// ./app/config/togglePercentagesComponent.js